<template>
  <template v-for="index in leadingBreaks" :key="`leading-${index}`">
    <br>
  </template>

  <template v-for="(block, blockIndex) in blocks" :key="block.id || `block-${blockIndex}`">
    <div v-if="block.type === 'text'" :class="block.className">{{ t(block.textKey) }}</div>

    <div v-else-if="block.type === 'richText'" :class="block.className">
      <template v-for="(segment, segmentIndex) in block.segments" :key="segment.textKey || segment.text || segmentIndex">
        <span :class="segment.className">{{ getSegmentContent(segment) }}</span>
      </template>
    </div>

    <ImageShow v-else-if="block.type === 'image'" :url="imageMap[block.imageKey]"/>
    <DeferredVideoPlayer
      v-else-if="block.type === 'video'"
      :poster="imageMap[block.posterImageKey]"
      :src="block.srcFactory"
    />
    <br>
  </template>

  <template v-for="index in trailingBreaks" :key="`trailing-${index}`">
    <br>
  </template>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import DeferredVideoPlayer from "@/views/FileDoc/components/DeferredVideoPlayer.vue";
import ImageShow from "@/views/FileDoc/components/ImageShow.vue";

defineProps({
  blocks: {
    type: Array,
    default: () => [],
  },
  imageMap: {
    type: Object,
    default: () => ({}),
  },
  leadingBreaks: {
    type: Number,
    default: 0,
  },
  trailingBreaks: {
    type: Number,
    default: 0,
  },
})

const {t} = useI18n()

const getSegmentContent = (segment) => segment.textKey ? t(segment.textKey) : (segment.text || "")
</script>

<style scoped>
.w700 {
  font-weight: 700;
}

.red {
  color: rgb(223, 42, 63);
}

.step {
  width: max-content;
  background: rgb(252, 231, 90);
}
</style>
